import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isEmpty } from 'app/helpers/immutable';
import { searchProbeShape } from 'app/shapes/search';
import SearchProbe from 'app/components/shared/Probes/components/search-probe';
import '../styles/SearchProbeList.scss';

function probeHasResults(probe) {
  return probe.count > 0;
}

function getTitle(probes) {
  if (probes.size > 0) {
    return (
      <h3 className="search-probe-title">
        <FormattedMessage id="also_found_at" />
      </h3>
    );
  }

  return (
    <div className="search-probe-no-results">
      <FormattedMessage id="search_probes_no_results" />
    </div>
  );
}

export default function SearchProbeList({ probes }) {
  if (!probes || isEmpty(probes)) {
    return null;
  }

  const probesWithResults = probes.filter(probeHasResults);

  return (
    <div className="cp-search-probe-list">
      {getTitle(probesWithResults)}
      <ul className="probe-list">
        {probesWithResults
          .map(probe => (
            <li key={probe.siteId}>
              <SearchProbe {...probe} />
            </li>
          ))
          .toArray()}
      </ul>
    </div>
  );
}

SearchProbeList.propTypes = {
  probes: ImmutablePropTypes.mapOf(searchProbeShape, PropTypes.string)
};
